import React, { useEffect } from 'react'
import { useState } from 'react'
import axios from 'axios'
import Gateway from './Gateway'
import Swal from "sweetalert2";


const img_base_url = "https://api.rrludo.in"; // backend base URL
export const Sitesettings = () => {


  const [upiList, setUpiList] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({
      upiId: "",
      limitFrom: "",
      limitTo: "",
      qrImage: null,
    });
  
    const [limits, setLimits] = useState({ gatewayMin: "", gatewayMax: "" });

      // Fetch Limits
      const fetchLimits = async () => {
        try {
          const { data } = await axios.get(`${img_base_url}/upi/limits`, {
            headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
          });
          if (data.status) setLimits(data.data);
        } catch {
          Swal.fire("Error", "Failed to fetch limits", "error");
        }
      };
    
    
    
      const handleUpdateLimits = async () => {
        try {
          const { data } = await axios.post(`${img_base_url}/upi/limits`, limits, {
            headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
          });
          if (data.status) Swal.fire("Success", "Limits updated", "success");
        } catch {
          Swal.fire("Error", "Failed to update limits", "error");
        }
      };


        useEffect(() => {
          fetchLimits();
        }, []);
      

  const [WebTitle, setWebTitle] = useState('')
  const [withdrawalLimitMin, setWithdrawalLimitMin] = useState('')
  const [withdrawalLimitMax, setWithdrawalLimitMax] = useState('')
  const [depositlimitMin, setDepositlimitMin] = useState('')
  const [withdrawTime, setwithdrawTime] = useState('')
  const [depositlimitMax, setDepositlimitMax] = useState('')
  const [commissionRangeludo, setcommissionRangeludo] = useState('')
  const [commissionRange2, setcommissionRange2] = useState('')
  const [referralCommission, setreferralCommission] = useState('')
  const [isUpiWithdrawal, setIsUpiWithdrawal] = useState(false)
  const [isBankWithdrawal, setIsBankWithdrawal] = useState(false)
  const [isWithdrawal, setIsWithdrawal] = useState(false)
  const [isDeposit, setIsDeposit] = useState(false)
  const [isImbpGateway, setisImbpGateway] = useState(false)
  const [isGameRules, setisGameRules] = useState(false)
  const [isFairPlay, setisFairPlay] = useState(false)
  const [siteMaintenance, setSiteMaintenance] = useState(false)
  const [gameSearch, setGameSearch] = useState(false)
  const [userCanLogin, setUserCanLogin] = useState(false)
  const [autoSwitch, setAutoSwitch] = useState(false)
  const [isManualDeposit, setIsManualDeposit] = useState(false)
  const [refRedeemMin, setRefRedeemMin] = useState('')
  const [refRedeemMax, setRefRedeemMax] = useState('')
  const [WebsiteName, setWebName] = useState('')
  const [homeMsg, setHomeMsg] = useState('')
  const [ludoClassicsMsg, setLudoClassicsMsg] = useState('')
  const [rk1g, setRk1g] = useState('')
  const [rk3g, setRk3g] = useState('')
  const [rkRummyMsg, setRkRummyMsg] = useState('')
  const [CompanyName, setCompanyName] = useState('')
  const [CompanyAddress, setCompanyAddress] = useState('')
  const [CompanyMobile, setCompanyMobile] = useState('')
  const [whatsappSupport, setwhatsappSupport] = useState('')
  const [Logo, setLogo] = useState('')
  const [SmallLogo, setSmallLogo] = useState('')

  const [LandingImage1, setLandingImage1] = useState('')
  const [LandingImage2, setLandingImage2] = useState('')
  const [LandingImage3, setLandingImage3] = useState('')
  const [LandingImage4, setLandingImage4] = useState('')

  const [isLandingImage1, issetLandingImage1] = useState(true)
  const [isLandingImage2, issetLandingImage2] = useState(true)
  const [isLandingImage3, issetLandingImage3] = useState(true)
  const [isLandingImage4, issetLandingImage4] = useState(true)

  const [version, setVersion] = useState('')

  const [settingId, setSettingId] = useState('')

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API
  const nodeMode = process.env.NODE_ENV
  if (nodeMode === 'development') {
    var baseUrl = beckendLocalApiUrl
  } else {
    baseUrl = beckendLiveApiUrl
  }

  useEffect(() => {
    const data = axios.get(baseUrl + 'settings/data', {}).then((res) => {
      setSettingId(res.data._id ? res.data._id : '')
      setWebTitle(res.data.WebTitle)
      setWithdrawalLimitMin(res.data.withdrawalLimitMin)
      setWithdrawalLimitMax(res.data.withdrawalLimitMax)
      setIsUpiWithdrawal(res.data.isUpiWithdrawal)
      setIsBankWithdrawal(res.data.isBankWithdrawal)
      setIsWithdrawal(res.data.isWithdrawal)
      setIsDeposit(res.data.isDeposit)
      setisImbpGateway(res.data.isImbpGateway)
      setSiteMaintenance(res.data.siteMaintenance)
      setGameSearch(res.data.gameSearch)
      setUserCanLogin(res.data.userCanLogin)
      setAutoSwitch(res.data.autoSwitch)
      setDepositlimitMax(res.data.depositlimitMax)
      setcommissionRangeludo(res?.data?.commissionRangeludo)
      setcommissionRange2(res?.data?.commissionRange2)
      setreferralCommission(res?.data?.referralCommission)
      setDepositlimitMin(res.data.depositlimitMin)
      setisGameRules(res.data.isGameRules)
      setisFairPlay(res.data.isFairPlay)
      setIsManualDeposit(res.data.isManualDeposit)
      setRefRedeemMin(res.data.refRedeemMin)
      setRefRedeemMax(res.data.refRedeemMax)
      setWebName(res.data.WebsiteName)
      setHomeMsg(res.data.homeMsg)
      setwithdrawTime(res.data.withdrawTime)
      setLudoClassicsMsg(res.data.ludoClassicsMsg)
      setRk1g(res.data.rk1g)
      setRk3g(res.data.rk3g)
      setRkRummyMsg(res.data.rkRummyMsg)
      setCompanyName(res.data.CompanyName)
      setCompanyAddress(res.data.CompanyAddress)
      setCompanyMobile(res.data.CompanyMobile)
      setwhatsappSupport(res.data.whatsappSupport)
      setLogo(res.data.Logo)
      setSmallLogo(res.data.SmallLogo)
      setLandingImage1(res.data.LandingImage1)
      setLandingImage2(res.data.LandingImage2)
      setLandingImage3(res.data.LandingImage3)
      setLandingImage4(res.data.LandingImage4)
      issetLandingImage1(res.data.isLandingImage1)
      issetLandingImage2(res.data.isLandingImage2)
      issetLandingImage3(res.data.isLandingImage3)
      issetLandingImage4(res.data.isLandingImage4)
      setVersion(res.data.version)
    })
  }, [])



  const handleSubmit = async (e) => {
    e.preventDefault()
    let formData = new FormData()
    formData.append('settingId', settingId)
    formData.append('WebTitle', WebTitle)
    formData.append("withdrawalLimitMin", withdrawalLimitMin)
    formData.append("withdrawalLimitMax", withdrawalLimitMax)
    formData.append("isUpiWithdrawal", isUpiWithdrawal)
    formData.append("isBankWithdrawal", isBankWithdrawal)
    formData.append("isWithdrawal", isWithdrawal)
    formData.append("isDeposit", isDeposit)
    formData.append("isImbpGateway", isImbpGateway)
    formData.append("withdrawTime", withdrawTime)
    formData.append("commissionRangeludo", commissionRangeludo)
    formData.append("commissionRange2", commissionRange2)
    formData.append("referralCommission", referralCommission)
    formData.append("siteMaintenance", siteMaintenance)
    formData.append("gameSearch", gameSearch)
    formData.append("userCanLogin", userCanLogin)
    formData.append("autoSwitch", autoSwitch)
    formData.append("depositlimitMin", depositlimitMin)
    formData.append("depositlimitMax", depositlimitMax)
     formData.append("isGameRules", isGameRules)
    formData.append("isFairPlay", isFairPlay)
    formData.append("isManualDeposit", isManualDeposit)
    formData.append("refRedeemMin", refRedeemMin)
    formData.append("refRedeemMax", refRedeemMax)
    formData.append("homeMsg", homeMsg)
    formData.append("ludoClassicsMsg", ludoClassicsMsg)
    formData.append("rk1g", rk1g)
    formData.append("rk3g", rk3g)
    formData.append("rkRummyMsg", rkRummyMsg)
    formData.append('WebsiteName', WebsiteName)
    formData.append('CompanyName', CompanyName)
    formData.append('CompanyAddress', CompanyAddress)
    formData.append('CompanyMobile', CompanyMobile)
    formData.append('whatsappSupport', whatsappSupport)
    formData.append('Logo', Logo)
    formData.append('SmallLogo', SmallLogo)
    formData.append('LandingImage1', LandingImage1)
    formData.append('LandingImage2', LandingImage2)
    formData.append('LandingImage3', LandingImage3)
    formData.append('LandingImage4', LandingImage4)
    formData.append('isLandingImage1', isLandingImage1)
    formData.append('isLandingImage2', isLandingImage2)
    formData.append('isLandingImage3', isLandingImage3)
    formData.append('isLandingImage4', isLandingImage4)
    formData.append('version', version)
    const response = await axios.post(baseUrl + `settings`, formData)
    if (response.data.status === 'success') {
      alert('Settings submitted successfully')
    } else {
      alert('Settings Not Submitted')
    }
  }

  useEffect(() => {
    const Logo1 = document.getElementById('Logo')
    const Logo2 = document.getElementById('SmallLogo')
    const LandingImage1 = document.getElementById('LandingImage1')
    const LandingImage2 = document.getElementById('LandingImage2')
    const LandingImage3 = document.getElementById('LandingImage3')
    const LandingImage4 = document.getElementById('LandingImage4')

    Logo1.onchange = (e) => {
      const [file] = Logo1.files
      setLogo(file)
    }
    Logo2.onchange = (e) => {
      const [file] = Logo2.files
      setSmallLogo(file)
    }

  }, [])

  return (
    <>
      <div className="other_page_cards_main">
        <h3 className=" my-3 other_page_cards_heading">Website Settings</h3>

        <h4 className=" my-3 other_page_cards_heading_small">UI Settings</h4>
        <form
          onSubmit={handleSubmit}
          method="patch"
          encType="multipart/form-data"
          className="border_bottom"

        >
          <div className="form-row">
            <div className="form-group col-md-4">
              <label htmlFor="WebsiteName">Website Title</label>
              <input
                className="form-control"
                type="text"
                value={WebTitle}
                onChange={(e) => setWebTitle(e.target.value)}
              />
            </div>

            <div className="form-group col-md-4">
              <label htmlFor="WebsiteName">Refer redeem Min</label>
              <input
                className="form-control"
                type="text"
                value={refRedeemMin}
                onChange={(e) => setRefRedeemMin(e.target.value)}
              />
            </div>
            <div className="form-group col-md-4">
              <label htmlFor="WebsiteName">Refer redeem Max</label>
              <input
                className="form-control"
                type="text"
                value={refRedeemMax}
                onChange={(e) => setRefRedeemMax(e.target.value)}
              />
            </div>



            <div className="form-group col-md-4">
              <label htmlFor="WebsiteName">Website Name</label>
              <input
                className="form-control"
                type="text"
                value={WebsiteName}
                onChange={(e) => setWebName(e.target.value)}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group col-md-4">
              <label htmlFor="WebsiteName">Commpany Name</label>
              <input
                className="form-control"
                type="text"
                value={CompanyName}
                onChange={(e) => setCompanyName(e.target.value)}
              />
            </div>

            <div className="form-group col-md-4">
              <label htmlFor="WebsiteName">Commpany Address</label>
              <input
                className="form-control"
                type="text"
                value={CompanyAddress}
                onChange={(e) => setCompanyAddress(e.target.value)}
              />
            </div>

            <div className="form-group col-md-4">
              <label htmlFor="WebsiteName">Commpany Mobile</label>
              <input
                className="form-control"
                type="text"
                value={CompanyMobile}
                onChange={(e) => setCompanyMobile(e.target.value)}
              />
            </div>
            <div className="form-group col-md-4">
              <label htmlFor="WebsiteName">WhatsApp Support</label>
              <input
                className="form-control"
                type="text"
                value={whatsappSupport}
                onChange={(e) => setwhatsappSupport(e.target.value)}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group col-md-4">
              <label htmlFor="WebsiteName">Right Logo</label>
              <input
                className="form-control"
                type="file"
                name="Logo"
                id="Logo"
              />
            </div>

            <div className="form-group col-md-4">
              <label htmlFor="WebsiteName">Left Logo</label>
              <input
                className="form-control"
                type="file"
                name="SmallLogo"
                id="SmallLogo"
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group col-md-4">
              <button type="submit" className="btn btn-dark">
                submit
              </button>
            </div>
          </div>
        </form>
        {/* game comssion setting */}

        <div>
          <h4 className=" my-3 other_page_cards_heading_small">Comission  Settings</h4>
          <form onSubmit={handleSubmit}
            method="patch"
            encType="multipart/form-data"
            className="border_bottom">

            <div className="form-row">



              <div className="form-group col-md-4">
                <label htmlFor="WebsiteName">Referral Comission Rang</label>
                <input
                  className="form-control"
                  type="text"
                  value={referralCommission}
                  onChange={(e) => setreferralCommission(e.target.value)}
                />
              </div>
              <div className="form-group col-md-4">
                <label htmlFor="WebsiteName">50 to 500 Rang</label>
                <input
                  className="form-control"
                  type="text"
                  value={commissionRangeludo}
                  onChange={(e) => setcommissionRangeludo(e.target.value)}
                />
              </div>
              <div className="form-group col-md-4">
                <label htmlFor="WebsiteName">500 Above Rang</label>
                <input
                  className="form-control"
                  type="text"
                  value={commissionRange2}
                  onChange={(e) => setcommissionRange2(e.target.value)}
                />
              </div>



            </div>

            <div className="form-row">
              <div className="form-group col-md-4">
                <button type="submit" className="btn btn-dark">
                  submit
                </button>
              </div>
            </div>


          </form>
        </div>

        {/* Deposit manage */}

        <div>
          <h4 className=" my-3 other_page_cards_heading_small">Deposit  Settings</h4>
          <form onSubmit={handleSubmit}
            method="patch"
            encType="multipart/form-data"
            className="border_bottom">

            <div className="form-row">
              {/* Withdraw manage */}
              <div className="form-group col-md-4">
                <label htmlFor="buttonrazpay" className="">
                  Deposit
                </label>
                <select
                  className="form-control"
                  value={isDeposit}
                  onChange={(e) => setIsDeposit(e.target.value === "true")}
                >
                  <option value="true">Enable</option>
                  <option value="false">Disable</option>
                </select>
              </div>
              <div className="form-group col-md-4">
                <label htmlFor="buttonrazpay" className="">
                  IMB GATEWAY 
                </label>
                <select
                  className="form-control"
                  value={isImbpGateway}
                  onChange={(e) => setisImbpGateway(e.target.value === "true")}
                >
                  <option value="true">Enable</option>
                  <option value="false">Disable</option>
                </select>
              </div>
               <div className="form-group col-md-4">
                <label htmlFor="buttonrazpay" className="">
                  ROOMCODE AUTO/MANUAL
                </label>
                <select
                  className="form-control"
                  value={isGameRules}
                  onChange={(e) => setisGameRules(e.target.value === "true")}
                >
                  <option value="true">Enable</option>
                  <option value="false">Disable</option>
                </select>
              </div>
              <div className="form-group col-md-4">
                <label htmlFor="buttonrazpay" className="">
                  RESULT AUTO/MANUAL
                </label>
                <select
                  className="form-control"
                  value={isFairPlay}
                  onChange={(e) => setisFairPlay(e.target.value === "true")}
                >
                  <option value="true">Enable</option>
                  <option value="false">Disable</option>
                </select>
              </div>
              {/* <div className="form-group col-md-4">
                <label htmlFor="buttonrazpay" className="">
                  Auto deposit
                </label>
                <select
                  className="form-control"
                  value={autoSwitch}
                  onChange={(e) => setAutoSwitch(e.target.value === "true")}
                >
                  <option value="true">Enable</option>
                  <option value="false">Disable</option>
                </select>
              </div> */}
              <div className="form-group col-md-4">
                <label htmlFor="buttonrazpay" className="">
                  Manual deposit
                </label>
                <select
                  className="form-control"
                  value={isManualDeposit}
                  onChange={(e) => setIsManualDeposit(e.target.value === "true")}
                >
                  <option value="true">Enable</option>
                  <option value="false">Disable</option>
                </select>
              </div>
              <div className="form-group col-md-4">
                <label htmlFor="WebsiteName">Deposit Limit Min</label>
                <input
                  className="form-control"
                  type="text"
                  value={depositlimitMin}
                  onChange={(e) => setDepositlimitMin(e.target.value)}
                />
              </div>
              <div className="form-group col-md-4">
                <label htmlFor="WebsiteName">Deposit Limit Max</label>
                <input
                  className="form-control"
                  type="text"
                  value={depositlimitMax}
                  onChange={(e) => setDepositlimitMax(e.target.value)}
                />
              </div>



            </div>

            <div className="form-row">
              <div className="form-group col-md-4">
                <button type="submit" className="btn btn-dark">
                  submit
                </button>
              </div>
            </div>


          </form>
        </div>
         <div className="d-flex justify-content-between align-items-center mb-3 " style={{ flexDirection: "column-reverse" }}>
        <div className="card p-3 shadow-sm mb-4">
          <form onSubmit={handleSubmit}
            method="patch"
            encType="multipart/form-data"
            className="border_bottom">
           <div className="form-group col-md-4">
                <label htmlFor="buttonrazpay" className="">
                  Auto deposit on/off
                </label>
                <select
                  className="form-control"
                  value={autoSwitch}
                  onChange={(e) => setAutoSwitch(e.target.value === "true")}
                >
                  <option value="true">Enable</option>
                  <option value="false">Disable</option>
                </select>
              </div>
               <div className="form-row">
              <div className="form-group col-md-4">
                <button type="submit" className="btn btn-dark">
                  submit
                </button>
              </div>
            </div>
              </form>
          <h5 className="mb-3">Set Gateway  Limits</h5>
          <div className="row g-2">
            {["gatewayMin", "gatewayMax"].map((key) => (
              <div className="col-md-3" key={key}>
                <input
                  type="number"
                  className="form-control"
                  placeholder={key}
                  value={limits[key]}
                  onChange={(e) => setLimits({ ...limits, [key]: e.target.value })}
                />
              </div>
            ))}
          </div>
          <button className="btn btn-success mt-3" onClick={handleUpdateLimits}>
            💾 Save Limits
          </button>
        </div>
        
      </div>
        {/* Withdraw manage */}
        <div>
          <h4 className=" my-3 other_page_cards_heading_small">Withdraw  Settings</h4>
          <form onSubmit={handleSubmit}
            method="patch"
            encType="multipart/form-data"
            className="border_bottom">

            <div className="form-row">

              <div className="form-group col-md-4">
                <label htmlFor="buttonrazpay" className="">
                  Withdrawal
                </label>
                <select
                  className="form-control"
                  value={isWithdrawal}
                  onChange={(e) => setIsWithdrawal(e.target.value === "true")}
                >
                  <option value="true">Enable</option>
                  <option value="false">Disable</option>
                </select>
              </div>
              <div className="form-group col-md-4">
                <label htmlFor="buttonrazpay" className="">
                  Upi withdraw
                </label>
                <select
                  className="form-control"
                  value={isUpiWithdrawal}
                  onChange={(e) => setIsUpiWithdrawal(e.target.value === "true")}
                >
                  <option value="true">Enable</option>
                  <option value="false">Disable</option>
                </select>
              </div>
              <div className="form-group col-md-4">
                <label htmlFor="buttonrazpay" className="">
                  Bank withdraw
                </label>
                <select
                  className="form-control"
                  value={isBankWithdrawal}
                  onChange={(e) => setIsBankWithdrawal(e.target.value === "true")}
                >
                  <option value="true">Enable</option>
                  <option value="false">Disable</option>
                </select>
              </div>
              <div className="form-group col-md-4">
                <label htmlFor="WebsiteName">Withdrawal Limit Min</label>
                <input
                  className="form-control"
                  type="text"
                  value={withdrawalLimitMin}
                  onChange={(e) => setWithdrawalLimitMin(e.target.value)}
                />
              </div>
              <div className="form-group col-md-4">
                <label htmlFor="WebsiteName">Withdrawal Limit Max</label>
                <input
                  className="form-control"
                  type="text"
                  value={withdrawalLimitMax}
                  onChange={(e) => setWithdrawalLimitMax(e.target.value)}
                />
              </div>

              <div className="form-group col-md-4">
                <label htmlFor="WebsiteName">Withdrawal Time (in minutes)</label>
                <input
                  className="form-control"
                  type="number"
                  value={withdrawTime ? withdrawTime / 60000 : ''}
                  onChange={(e) => {
                    const value = Number(e.target.value);
                    setwithdrawTime(isNaN(value) ? 0 : value * 60 * 1000); // Convert minutes → milliseconds
                  }}
                />
              </div>


            </div>

            <div className="form-row">
              <div className="form-group col-md-4">
                <button type="submit" className="btn btn-dark">
                  submit
                </button>
              </div>
            </div>


          </form>
        </div>

        {/* Emegennncy  manage */}
        <div>
          <h4 className=" my-3 other_page_cards_heading_small">Emegennncy  Settings</h4>
          <form onSubmit={handleSubmit}
            method="patch"
            encType="multipart/form-data"
            className="border_bottom">

            <div className="form-row">

              <div className="form-group col-md-4">
                <label htmlFor="buttonrazpay" className="">
                  Site Maintaince
                </label>
                <select
                  className="form-control"
                  value={siteMaintenance}
                  onChange={(e) => setSiteMaintenance(e.target.value === "true")}
                >
                  <option value="true">Enable</option>
                  <option value="false">Disable</option>
                </select>
              </div>
              <div className="form-group col-md-4">
                <label htmlFor="buttonrazpay" className="">
                  Game Search
                </label>
                <select
                  className="form-control"
                  value={gameSearch}
                  onChange={(e) => setGameSearch(e.target.value === "true")}
                >
                  <option value="true">Enable</option>
                  <option value="false">Disable</option>
                </select>
              </div>
              <div className="form-group col-md-4">
                <label htmlFor="buttonrazpay" className="">
                  User Login
                </label>
                <select
                  className="form-control"
                  value={userCanLogin}
                  onChange={(e) => setUserCanLogin(e.target.value === "true")}
                >
                  <option value="true">Enable</option>
                  <option value="false">Disable</option>
                </select>
              </div>



            </div>

            <div className="form-row">
              <div className="form-group col-md-4">
                <button type="submit" className="btn btn-dark">
                  submit
                </button>
              </div>
            </div>


          </form>
        </div>




        {/* NOTICE MANAGE */}
        <div>
          <h4 className=" my-3 other_page_cards_heading_small">Screen Message Settings</h4>
          <form onSubmit={handleSubmit}
            method="patch"
            encType="multipart/form-data"
            className="border_bottom">

            <div className="form-row">

              <div className="form-group col-md-4">
                <label htmlFor="WebsiteName">Home Screen Msg</label>
                <input
                  className="form-control"
                  type="text"
                  value={homeMsg}
                  onChange={(e) => setHomeMsg(e.target.value)}
                />
              </div>
              <div className="form-group col-md-4">
                <label htmlFor="WebsiteName">Classic Screen Msg</label>
                <input
                  className="form-control"
                  type="text"
                  value={ludoClassicsMsg}
                  onChange={(e) => setLudoClassicsMsg(e.target.value)}
                />
              </div>
              <div className="form-group col-md-4">
                <label htmlFor="WebsiteName">Withdraw Screen Msg</label>
                <input
                  className="form-control"
                  type="text"
                  value={rk1g}
                  onChange={(e) => setRk1g(e.target.value)}
                />
              </div>
              <div className="form-group col-md-4">
                <label htmlFor="WebsiteName">Deposit Screen Msg</label>
                <input
                  className="form-control"
                  type="text"
                  value={rkRummyMsg}
                  onChange={(e) => setRkRummyMsg(e.target.value)}
                />
              </div>
              <div className="form-group col-md-4">
                <label htmlFor="WebsiteName">Site Maintaince Screen Msg</label>
                <input
                  className="form-control"
                  type="text"
                  value={rk3g}
                  onChange={(e) => setRk3g(e.target.value)}
                />
              </div>

            </div>

            <div className="form-row">
              <div className="form-group col-md-4">
                <button type="submit" className="btn btn-dark">
                  submit
                </button>
              </div>
            </div>


          </form>
        </div>



        {/* <Gateway /> */}
      </div>
    </>
  )
}




// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import Swal from 'sweetalert2';
// import Gateway from './Gateway'; // Assuming this component exists and handles UPI QR list
// import {
//   FaCog,
//   FaMoneyBillWave,
//   FaPercentage,
//   FaExclamationTriangle,
//   FaFileImage,
//   FaSave,
//   FaGlobe,
//   FaChartLine,
//   FaCommentDots,
//   FaClock,
// } from 'react-icons/fa'; // Importing useful icons

// const img_base_url = 'https://api.rrludo.in'; // backend base URL

// export const Sitesettings = () => {
//   // --- State Hooks ---
//   const [limits, setLimits] = useState({ gatewayMin: '', gatewayMax: '' });
//   const [activeTab, setActiveTab] = useState('general'); // State to manage active tab

//   // Site Settings States (Kept original variable names)
//   const [WebTitle, setWebTitle] = useState('');
//   const [withdrawalLimitMin, setWithdrawalLimitMin] = useState('');
//   const [withdrawalLimitMax, setWithdrawalLimitMax] = useState('');
//   const [depositlimitMin, setDepositlimitMin] = useState('');
//   const [withdrawTime, setwithdrawTime] = useState('');
//   const [depositlimitMax, setDepositlimitMax] = useState('');
//   const [commissionRangeludo, setcommissionRangeludo] = useState('');
//   const [commissionRange2, setcommissionRange2] = useState('');
//   const [referralCommission, setreferralCommission] = useState('');
//   const [isUpiWithdrawal, setIsUpiWithdrawal] = useState(false);
//   const [isBankWithdrawal, setIsBankWithdrawal] = useState(false);
//   const [isWithdrawal, setIsWithdrawal] = useState(false);
//   const [isDeposit, setIsDeposit] = useState(false);
//   const [siteMaintenance, setSiteMaintenance] = useState(false);
//   const [gameSearch, setGameSearch] = useState(false);
//   const [userCanLogin, setUserCanLogin] = useState(false);
//   const [autoSwitch, setAutoSwitch] = useState(false);
//   const [isManualDeposit, setIsManualDeposit] = useState(false);
//   const [refRedeemMin, setRefRedeemMin] = useState('');
//   const [refRedeemMax, setRefRedeemMax] = useState('');
//   const [WebsiteName, setWebName] = useState('');
//   const [homeMsg, setHomeMsg] = useState('');
//   const [ludoClassicsMsg, setLudoClassicsMsg] = useState('');
//   const [rk1g, setRk1g] = useState('');
//   const [rk3g, setRk3g] = useState('');
//   const [rkRummyMsg, setRkRummyMsg] = useState('');
//   const [CompanyName, setCompanyName] = useState('');
//   const [CompanyAddress, setCompanyAddress] = useState('');
//   const [CompanyMobile, setCompanyMobile] = useState('');
//   const [whatsappSupport, setwhatsappSupport] = useState('');
//   const [Logo, setLogo] = useState('');
//   const [SmallLogo, setSmallLogo] = useState('');
//   const [LandingImage1, setLandingImage1] = useState('');
//   const [LandingImage2, setLandingImage2] = useState('');
//   const [LandingImage3, setLandingImage3] = useState('');
//   const [LandingImage4, setLandingImage4] = useState('');
//   const [isLandingImage1, issetLandingImage1] = useState(true);
//   const [isLandingImage2, issetLandingImage2] = useState(true);
//   const [isLandingImage3, issetLandingImage3] = useState(true);
//   const [isLandingImage4, issetLandingImage4] = useState(true);
//   const [version, setVersion] = useState('');
//   const [settingId, setSettingId] = useState('');

//   // --- API Configuration ---
//   const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
//   const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
//   const nodeMode = process.env.NODE_ENV;
//   const baseUrl = nodeMode === 'development' ? beckendLocalApiUrl : beckendLiveApiUrl;
  
//   // --- Functions ---

//   // Fetch Limits (Moved here for clean separation)
//   const fetchLimits = async () => {
//     try {
//       const { data } = await axios.get(`${img_base_url}/upi/limits`, {
//         headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
//       });
//       if (data.status) setLimits(data.data);
//     } catch {
//       Swal.fire('Error', 'Failed to fetch limits', 'error');
//     }
//   };

//   // Update Limits
//   const handleUpdateLimits = async () => {
//     try {
//       const { data } = await axios.post(`${img_base_url}/upi/limits`, limits, {
//         headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
//       });
//       if (data.status) Swal.fire('Success', 'Gateway Limits updated successfully!', 'success');
//     } catch {
//       Swal.fire('Error', 'Failed to update limits', 'error');
//     }
//   };

//   // Main Settings Fetch
//   useEffect(() => {
//     fetchLimits();
//     const fetchSettings = async () => {
//       try {
//         const res = await axios.get(baseUrl + 'settings/data', {});
//         const data = res.data;
//         setSettingId(data._id || '');
//         setWebTitle(data.WebTitle);
//         setWithdrawalLimitMin(data.withdrawalLimitMin);
//         setWithdrawalLimitMax(data.withdrawalLimitMax);
//         setIsUpiWithdrawal(data.isUpiWithdrawal);
//         setIsBankWithdrawal(data.isBankWithdrawal);
//         setIsWithdrawal(data.isWithdrawal);
//         setIsDeposit(data.isDeposit);
//         setSiteMaintenance(data.siteMaintenance);
//         setGameSearch(data.gameSearch);
//         setUserCanLogin(data.userCanLogin);
//         setAutoSwitch(data.autoSwitch);
//         setDepositlimitMax(data.depositlimitMax);
//         setcommissionRangeludo(data?.commissionRangeludo);
//         setcommissionRange2(data?.commissionRange2);
//         setreferralCommission(data?.referralCommission);
//         setDepositlimitMin(data.depositlimitMin);
//         setIsManualDeposit(data.isManualDeposit);
//         setRefRedeemMin(data.refRedeemMin);
//         setRefRedeemMax(data.refRedeemMax);
//         setWebName(data.WebsiteName);
//         setHomeMsg(data.homeMsg);
//         setwithdrawTime(data.withdrawTime);
//         setLudoClassicsMsg(data.ludoClassicsMsg);
//         setRk1g(data.rk1g);
//         setRk3g(data.rk3g);
//         setRkRummyMsg(data.rkRummyMsg);
//         setCompanyName(data.CompanyName);
//         setCompanyAddress(data.CompanyAddress);
//         setCompanyMobile(data.CompanyMobile);
//         setwhatsappSupport(data.whatsappSupport);
//         setLogo(data.Logo);
//         setSmallLogo(data.SmallLogo);
//         setLandingImage1(data.LandingImage1);
//         setLandingImage2(data.LandingImage2);
//         setLandingImage3(data.LandingImage3);
//         setLandingImage4(data.LandingImage4);
//         issetLandingImage1(data.isLandingImage1);
//         issetLandingImage2(data.isLandingImage2);
//         issetLandingImage3(data.isLandingImage3);
//         issetLandingImage4(data.isLandingImage4);
//         setVersion(data.version);
//       } catch (error) {
//         console.error('Error fetching settings:', error);
//       }
//     };
//     fetchSettings();
//   }, []);

//   // Handle file uploads separately
//   useEffect(() => {
//     const Logo1 = document.getElementById('Logo');
//     const Logo2 = document.getElementById('SmallLogo');
    
//     // Note: Landing images were not being attached to onchange in your original code. 
//     // If you need to handle landing image file changes, you'll need similar logic here 
//     // and matching IDs in the JSX.
    
//     if (Logo1) {
//       Logo1.onchange = (e) => {
//         const [file] = Logo1.files;
//         setLogo(file);
//       };
//     }
//     if (Logo2) {
//       Logo2.onchange = (e) => {
//         const [file] = Logo2.files;
//         setSmallLogo(file);
//       };
//     }

//   }, []);

//   // Main Settings Update Handler
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     let formData = new FormData();
//     formData.append('settingId', settingId);
//     formData.append('WebTitle', WebTitle);
//     formData.append('withdrawalLimitMin', withdrawalLimitMin);
//     formData.append('withdrawalLimitMax', withdrawalLimitMax);
//     formData.append('isUpiWithdrawal', isUpiWithdrawal);
//     formData.append('isBankWithdrawal', isBankWithdrawal);
//     formData.append('isWithdrawal', isWithdrawal);
//     formData.append('isDeposit', isDeposit);
//     formData.append('withdrawTime', withdrawTime);
//     formData.append('commissionRangeludo', commissionRangeludo);
//     formData.append('commissionRange2', commissionRange2);
//     formData.append('referralCommission', referralCommission);
//     formData.append('siteMaintenance', siteMaintenance);
//     formData.append('gameSearch', gameSearch);
//     formData.append('userCanLogin', userCanLogin);
//     formData.append('autoSwitch', autoSwitch);
//     formData.append('depositlimitMin', depositlimitMin);
//     formData.append('depositlimitMax', depositlimitMax);
//     formData.append('isManualDeposit', isManualDeposit);
//     formData.append('refRedeemMin', refRedeemMin);
//     formData.append('refRedeemMax', refRedeemMax);
//     formData.append('homeMsg', homeMsg);
//     formData.append('ludoClassicsMsg', ludoClassicsMsg);
//     formData.append('rk1g', rk1g);
//     formData.append('rk3g', rk3g);
//     formData.append('rkRummyMsg', rkRummyMsg);
//     formData.append('WebsiteName', WebsiteName);
//     formData.append('CompanyName', CompanyName);
//     formData.append('CompanyAddress', CompanyAddress);
//     formData.append('CompanyMobile', CompanyMobile);
//     formData.append('whatsappSupport', whatsappSupport);
//     formData.append('Logo', Logo);
//     formData.append('SmallLogo', SmallLogo);
//     formData.append('LandingImage1', LandingImage1);
//     formData.append('LandingImage2', LandingImage2);
//     formData.append('LandingImage3', LandingImage3);
//     formData.append('LandingImage4', LandingImage4);
//     formData.append('isLandingImage1', isLandingImage1);
//     formData.append('isLandingImage2', isLandingImage2);
//     formData.append('isLandingImage3', isLandingImage3);
//     formData.append('isLandingImage4', isLandingImage4);
//     formData.append('version', version);

//     try {
//         const response = await axios.post(baseUrl + `settings`, formData);
//         if (response.data.status === 'success') {
//           Swal.fire('Success', 'Site Settings updated successfully!', 'success');
//         } else {
//           Swal.fire('Error', 'Settings Not Submitted', 'error');
//         }
//     } catch (error) {
//         console.error('Submission error:', error);
//         Swal.fire('Error', 'An error occurred during submission', 'error');
//     }
//   };

//   // --- JSX Render ---
//   return (
//     <div className="container-fluid mt-4">
//       <div className="card shadow-sm">
//         <div className="card-header bg-primary text-white">
//           <h3 className="mb-0 fw-bold d-flex align-items-center">
//             <FaCog className="me-2" /> Website Configuration Panel
//           </h3>
//         </div>
//         <div className="card-body">
//           {/* Tabs Navigation */}
//           <ul className="nav nav-tabs mb-4" id="settingsTab" role="tablist">
//             <li className="nav-item" role="presentation">
//               <button
//                 className={`nav-link fw-bold ${activeTab === 'general' ? 'active' : ''}`}
//                 onClick={() => setActiveTab('general')}
//               >
//                 <FaGlobe className="me-1" /> General & Branding
//               </button>
//             </li>
//             <li className="nav-item" role="presentation">
//               <button
//                 className={`nav-link fw-bold ${activeTab === 'limits' ? 'active' : ''}`}
//                 onClick={() => setActiveTab('limits')}
//               >
//                 <FaChartLine className="me-1" /> Limits & Commissions
//               </button>
//             </li>
//             <li className="nav-item" role="presentation">
//               <button
//                 className={`nav-link fw-bold ${activeTab === 'payments' ? 'active' : ''}`}
//                 onClick={() => setActiveTab('payments')}
//               >
//                 <FaMoneyBillWave className="me-1" /> Payment Gateways
//               </button>
//             </li>
//             <li className="nav-item" role="presentation">
//               <button
//                 className={`nav-link fw-bold ${activeTab === 'emergency' ? 'active' : ''}`}
//                 onClick={() => setActiveTab('emergency')}
//               >
//                 <FaExclamationTriangle className="me-1" /> Messages & Emergency
//               </button>
//             </li>
//           </ul>
//           {/* --- Tab Content --- */}
//           <div className="tab-content" id="settingsTabContent">
//             {/* 1. General & Branding Settings */}
//             <div className={`tab-pane fade ${activeTab === 'general' ? 'show active' : ''}`}>
//                 <h4 className="mb-3 text-secondary fw-bold">Basic Site Details</h4>
//                 <form onSubmit={handleSubmit} className="mb-4">
//                     <div className="row g-3">
//                         <div className="col-md-4">
//                             <label className="form-label fw-medium">Website Title (SEO)</label>
//                             <input
//                                 className="form-control"
//                                 type="text"
//                                 value={WebTitle}
//                                 onChange={(e) => setWebTitle(e.target.value)}
//                             />
//                         </div>
//                         <div className="col-md-4">
//                             <label className="form-label fw-medium">Website Display Name</label>
//                             <input
//                                 className="form-control"
//                                 type="text"
//                                 value={WebsiteName}
//                                 onChange={(e) => setWebName(e.target.value)}
//                             />
//                         </div>
//                         <div className="col-md-4">
//                             <label className="form-label fw-medium">App Version</label>
//                             <input
//                                 className="form-control"
//                                 type="text"
//                                 value={version}
//                                 onChange={(e) => setVersion(e.target.value)}
//                             />
//                         </div>
//                     </div>
                    
//                     <h4 className="mt-4 mb-3 text-secondary fw-bold">Company & Contact Info</h4>
//                     <div className="row g-3">
//                         <div className="col-md-4">
//                             <label className="form-label fw-medium">Company Name</label>
//                             <input
//                                 className="form-control"
//                                 type="text"
//                                 value={CompanyName}
//                                 onChange={(e) => setCompanyName(e.target.value)}
//                             />
//                         </div>
//                         <div className="col-md-4">
//                             <label className="form-label fw-medium">Company Mobile</label>
//                             <input
//                                 className="form-control"
//                                 type="text"
//                                 value={CompanyMobile}
//                                 onChange={(e) => setCompanyMobile(e.target.value)}
//                             />
//                         </div>
//                         <div className="col-md-4">
//                             <label className="form-label fw-medium">WhatsApp Support Number</label>
//                             <input
//                                 className="form-control"
//                                 type="text"
//                                 value={whatsappSupport}
//                                 onChange={(e) => setwhatsappSupport(e.target.value)}
//                             />
//                         </div>
//                         <div className="col-md-12">
//                             <label className="form-label fw-medium">Company Address</label>
//                             <textarea
//                                 className="form-control"
//                                 rows="2"
//                                 value={CompanyAddress}
//                                 onChange={(e) => setCompanyAddress(e.target.value)}
//                             />
//                         </div>
//                     </div>
                    
//                     <h4 className="mt-4 mb-3 text-secondary fw-bold">Logos & Images</h4>
//                     <div className="row g-3">
//                         <div className="col-md-4">
//                             <label className="form-label fw-medium">Header/Main Logo</label>
//                             <input
//                                 className="form-control"
//                                 type="file"
//                                 name="Logo"
//                                 id="Logo"
//                                 accept="image/*"
//                             />
//                             {Logo && !Logo.name && <small className="d-block mt-1 text-muted">Current: {Logo.split('/').pop()}</small>}
//                         </div>
//                         <div className="col-md-4">
//                             <label className="form-label fw-medium">Small/Favicon Logo</label>
//                             <input
//                                 className="form-control"
//                                 type="file"
//                                 name="SmallLogo"
//                                 id="SmallLogo"
//                                 accept="image/*"
//                             />
//                             {SmallLogo && !SmallLogo.name && <small className="d-block mt-1 text-muted">Current: {SmallLogo.split('/').pop()}</small>}
//                         </div>
//                         <div className="col-md-4">
//                             <label className="form-label fw-medium">Landing Image 1 (Display Toggle)</label>
//                             <select
//                                 className="form-select"
//                                 value={isLandingImage1}
//                                 onChange={(e) => issetLandingImage1(e.target.value === 'true')}
//                             >
//                                 <option value="true">Show</option>
//                                 <option value="false">Hide</option>
//                             </select>
//                             {/* Hidden file input for LandingImage1 - Add similar logic for 2, 3, 4 */}
//                             <input type="file" name="LandingImage1" id="LandingImage1" className="d-none" />
//                         </div>
//                     </div>

//                     <div className="d-flex justify-content-end mt-4">
//                         <button type="submit" className="btn btn-dark w-25 d-flex align-items-center justify-content-center">
//                             <FaSave className="me-2" /> Save General Settings
//                         </button>
//                     </div>
//                 </form>
//             </div>
//             {/* 2. Limits & Commissions Settings */}
//             <div className={`tab-pane fade ${activeTab === 'limits' ? 'show active' : ''}`}>
//                 <h4 className="mb-3 text-secondary fw-bold">Deposit & Withdrawal Limits</h4>
//                 <form onSubmit={handleSubmit} className="mb-4">
//                     <div className="row g-3">
//                         <div className="col-md-3">
//                             <label className="form-label fw-medium">Deposit Min (₹)</label>
//                             <input
//                                 className="form-control"
//                                 type="number"
//                                 value={depositlimitMin}
//                                 onChange={(e) => setDepositlimitMin(e.target.value)}
//                             />
//                         </div>
//                         <div className="col-md-3">
//                             <label className="form-label fw-medium">Deposit Max (₹)</label>
//                             <input
//                                 className="form-control"
//                                 type="number"
//                                 value={depositlimitMax}
//                                 onChange={(e) => setDepositlimitMax(e.target.value)}
//                             />
//                         </div>
//                         <div className="col-md-3">
//                             <label className="form-label fw-medium">Withdrawal Min (₹)</label>
//                             <input
//                                 className="form-control"
//                                 type="number"
//                                 value={withdrawalLimitMin}
//                                 onChange={(e) => setWithdrawalLimitMin(e.target.value)}
//                             />
//                         </div>
//                         <div className="col-md-3">
//                             <label className="form-label fw-medium">Withdrawal Max (₹)</label>
//                             <input
//                                 className="form-control"
//                                 type="number"
//                                 value={withdrawalLimitMax}
//                                 onChange={(e) => setWithdrawalLimitMax(e.target.value)}
//                             />
//                         </div>
//                     </div>

//                     <h4 className="mt-4 mb-3 text-secondary fw-bold">Referral & Commission Settings</h4>
//                     <div className="row g-3">
//                         <div className="col-md-3">
//                             <label className="form-label fw-medium d-flex align-items-center">
//                                 <FaPercentage className="me-1" /> Referral Commission (%)
//                             </label>
//                             <input
//                                 className="form-control"
//                                 type="number"
//                                 value={referralCommission}
//                                 onChange={(e) => setreferralCommission(e.target.value)}
//                             />
//                         </div>
//                         <div className="col-md-3">
//                             <label className="form-label fw-medium">Refer Redeem Min (₹)</label>
//                             <input
//                                 className="form-control"
//                                 type="number"
//                                 value={refRedeemMin}
//                                 onChange={(e) => setRefRedeemMin(e.target.value)}
//                             />
//                         </div>
//                         <div className="col-md-3">
//                             <label className="form-label fw-medium">Refer Redeem Max (₹)</label>
//                             <input
//                                 className="form-control"
//                                 type="number"
//                                 value={refRedeemMax}
//                                 onChange={(e) => setRefRedeemMax(e.target.value)}
//                             />
//                         </div>
//                     </div>
//                     <div className="row g-3 mt-3">
//                         <div className="col-md-4">
//                             <label className="form-label fw-medium">Game Commission (₹50-₹500 Range) (%)</label>
//                             <input
//                                 className="form-control"
//                                 type="number"
//                                 value={commissionRangeludo}
//                                 onChange={(e) => setcommissionRangeludo(e.target.value)}
//                             />
//                         </div>
//                         <div className="col-md-4">
//                             <label className="form-label fw-medium">Game Commission (₹500+ Range) (%)</label>
//                             <input
//                                 className="form-control"
//                                 type="number"
//                                 value={commissionRange2}
//                                 onChange={(e) => setcommissionRange2(e.target.value)}
//                             />
//                         </div>
//                         <div className="col-md-4">
//                             <label className="form-label fw-medium d-flex align-items-center">
//                                 <FaClock className="me-1" /> Withdrawal Time (Minutes)
//                             </label>
//                             <input
//                                 className="form-control"
//                                 type="number"
//                                 value={withdrawTime ? withdrawTime / 60000 : ''}
//                                 onChange={(e) => {
//                                     const value = Number(e.target.value);
//                                     setwithdrawTime(isNaN(value) ? 0 : value * 60 * 1000); // Minutes to milliseconds
//                                 }}
//                             />
//                         </div>
//                     </div>

//                     <div className="d-flex justify-content-end mt-4">
//                         <button type="submit" className="btn btn-dark w-25 d-flex align-items-center justify-content-center">
//                             <FaSave className="me-2" /> Save Limits & Commissions
//                         </button>
//                     </div>
//                 </form>
//             </div>
//             {/* 3. Payment Gateways Settings */}
//             <div className={`tab-pane fade ${activeTab === 'payments' ? 'show active' : ''}`}>
                
//                 <h4 className="mb-3 text-secondary fw-bold">Global Gateway Limits</h4>
//                 <div className="card p-3 shadow-sm mb-4 bg-light">
//                     <div className="row g-3">
//                         <div className="col-md-4">
//                             <label className="form-label fw-medium">Gateway Global Min (₹)</label>
//                             <input
//                                 type="number"
//                                 className="form-control"
//                                 placeholder="Min Limit"
//                                 value={limits.gatewayMin}
//                                 onChange={(e) => setLimits({ ...limits, gatewayMin: e.target.value })}
//                             />
//                         </div>
//                         <div className="col-md-4">
//                             <label className="form-label fw-medium">Gateway Global Max (₹)</label>
//                             <input
//                                 type="number"
//                                 className="form-control"
//                                 placeholder="Max Limit"
//                                 value={limits.gatewayMax}
//                                 onChange={(e) => setLimits({ ...limits, gatewayMax: e.target.value })}
//                             />
//                         </div>
//                         <div className="col-md-4 d-flex align-items-end">
//                             <button className="btn btn-success w-100 d-flex align-items-center justify-content-center" onClick={handleUpdateLimits}>
//                                 <FaSave className="me-2" /> Update Gateway Limits
//                             </button>
//                         </div>
//                     </div>
//                 </div>

//                 <h4 className="mt-4 mb-3 text-secondary fw-bold">Deposit and Withdrawal Control</h4>
//                 <form onSubmit={handleSubmit} className="mb-4">
//                     <div className="row g-3">
//                         {/* Deposit Controls */}
//                         <div className="col-md-4">
//                             <label className="form-label fw-medium">Deposit Status</label>
//                             <select
//                                 className="form-select"
//                                 value={isDeposit}
//                                 onChange={(e) => setIsDeposit(e.target.value === 'true')}
//                             >
//                                 <option value="true">Enable</option>
//                                 <option value="false">Disable</option>
//                             </select>
//                         </div>
//                         <div className="col-md-4">
//                             <label className="form-label fw-medium">Auto Deposit Switch</label>
//                             <select
//                                 className="form-select"
//                                 value={autoSwitch}
//                                 onChange={(e) => setAutoSwitch(e.target.value === 'true')}
//                             >
//                                 <option value="true">Enable</option>
//                                 <option value="false">Disable</option>
//                             </select>
//                         </div>
//                         <div className="col-md-4">
//                             <label className="form-label fw-medium">Manual Deposit</label>
//                             <select
//                                 className="form-select"
//                                 value={isManualDeposit}
//                                 onChange={(e) => setIsManualDeposit(e.target.value === 'true')}
//                             >
//                                 <option value="true">Enable</option>
//                                 <option value="false">Disable</option>
//                             </select>
//                         </div>
//                     </div>
                    
//                     <div className="row g-3 mt-3">
//                         {/* Withdrawal Controls */}
//                         <div className="col-md-4">
//                             <label className="form-label fw-medium">Withdrawal Status</label>
//                             <select
//                                 className="form-select"
//                                 value={isWithdrawal}
//                                 onChange={(e) => setIsWithdrawal(e.target.value === 'true')}
//                             >
//                                 <option value="true">Enable</option>
//                                 <option value="false">Disable</option>
//                             </select>
//                         </div>
//                         <div className="col-md-4">
//                             <label className="form-label fw-medium">UPI Withdrawal</label>
//                             <select
//                                 className="form-select"
//                                 value={isUpiWithdrawal}
//                                 onChange={(e) => setIsUpiWithdrawal(e.target.value === 'true')}
//                             >
//                                 <option value="true">Enable</option>
//                                 <option value="false">Disable</option>
//                             </select>
//                         </div>
//                         <div className="col-md-4">
//                             <label className="form-label fw-medium">Bank Withdrawal</label>
//                             <select
//                                 className="form-select"
//                                 value={isBankWithdrawal}
//                                 onChange={(e) => setIsBankWithdrawal(e.target.value === 'true')}
//                             >
//                                 <option value="true">Enable</option>
//                                 <option value="false">Disable</option>
//                             </select>
//                         </div>
//                     </div>
                    
//                     <div className="d-flex justify-content-end mt-4">
//                         <button type="submit" className="btn btn-dark w-25 d-flex align-items-center justify-content-center">
//                             <FaSave className="me-2" /> Save Payment Settings
//                         </button>
//                     </div>
//                 </form>

//                 {/* UPI QR Code Management (using the imported Gateway component) */}
//                 <h4 className="mt-5 mb-3 text-secondary fw-bold">UPI/QR Management</h4>
//                 <p className="text-muted">Use the Gateway component below to add, view, and manage individual UPI IDs and QR codes.</p>
//                 {/* <Gateway />  <- Uncomment this when the component is ready */}
//                 <div className="alert alert-warning">
//                     **Note:** The `Gateway` component is assumed to be defined externally (like in the previous request). The actual UPI list and actions will be handled there.
//                 </div>
//             </div>
//             {/* 4. Messages & Emergency Settings */}
//             <div className={`tab-pane fade ${activeTab === 'emergency' ? 'show active' : ''}`}>
//                 <h4 className="mb-3 text-secondary fw-bold">Emergency Controls</h4>
//                 <form onSubmit={handleSubmit} className="mb-4">
//                     <div className="row g-3">
//                         <div className="col-md-4">
//                             <label className="form-label fw-medium">Site Maintenance Mode</label>
//                             <select
//                                 className="form-select"
//                                 value={siteMaintenance}
//                                 onChange={(e) => setSiteMaintenance(e.target.value === 'true')}
//                             >
//                                 <option value="true">Enable (Restrict Access)</option>
//                                 <option value="false">Disable (Allow Access)</option>
//                             </select>
//                         </div>
//                         <div className="col-md-4">
//                             <label className="form-label fw-medium">Game Search (Lobby)</label>
//                             <select
//                                 className="form-select"
//                                 value={gameSearch}
//                                 onChange={(e) => setGameSearch(e.target.value === 'true')}
//                             >
//                                 <option value="true">Enable</option>
//                                 <option value="false">Disable</option>
//                             </select>
//                         </div>
//                         <div className="col-md-4">
//                             <label className="form-label fw-medium">User Login</label>
//                             <select
//                                 className="form-select"
//                                 value={userCanLogin}
//                                 onChange={(e) => setUserCanLogin(e.target.value === 'true')}
//                             >
//                                 <option value="true">Enable</option>
//                                 <option value="false">Disable</option>
//                             </select>
//                         </div>
//                     </div>

//                     <h4 className="mt-4 mb-3 text-secondary fw-bold d-flex align-items-center">
//                         <FaCommentDots className="me-2"/> Screen Messages
//                     </h4>
//                     <div className="row g-3">
//                         <div className="col-md-6">
//                             <label className="form-label fw-medium">Home Screen Message</label>
//                             <input
//                                 className="form-control"
//                                 type="text"
//                                 value={homeMsg}
//                                 onChange={(e) => setHomeMsg(e.target.value)}
//                             />
//                         </div>
//                         <div className="col-md-6">
//                             <label className="form-label fw-medium">Ludo Classic Screen Message</label>
//                             <input
//                                 className="form-control"
//                                 type="text"
//                                 value={ludoClassicsMsg}
//                                 onChange={(e) => setLudoClassicsMsg(e.target.value)}
//                             />
//                         </div>
//                         <div className="col-md-4">
//                             <label className="form-label fw-medium">Withdraw Screen Message (rk1g)</label>
//                             <input
//                                 className="form-control"
//                                 type="text"
//                                 value={rk1g}
//                                 onChange={(e) => setRk1g(e.target.value)}
//                             />
//                         </div>
//                         <div className="col-md-4">
//                             <label className="form-label fw-medium">Deposit Screen Message (rkRummyMsg)</label>
//                             <input
//                                 className="form-control"
//                                 type="text"
//                                 value={rkRummyMsg}
//                                 onChange={(e) => setRkRummyMsg(e.target.value)}
//                             />
//                         </div>
//                         <div className="col-md-4">
//                             <label className="form-label fw-medium">Maintenance Screen Message (rk3g)</label>
//                             <input
//                                 className="form-control"
//                                 type="text"
//                                 value={rk3g}
//                                 onChange={(e) => setRk3g(e.target.value)}
//                             />
//                         </div>
//                     </div>

//                     <div className="d-flex justify-content-end mt-4">
//                         <button type="submit" className="btn btn-dark w-25 d-flex align-items-center justify-content-center">
//                             <FaSave className="me-2" /> Save Emergency & Messages
//                         </button>
//                     </div>
//                 </form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };